import React, { useCallback } from 'react'
import Globals from 'system/Globals'
import styles from './controller-narrative.module.css'
import mstyles from '../narrative/modules/modules.module.css'
import { ReactComponent as CloseButton } from '../assets/icons/close.svg'
import ControllerModalBrowserChrome from './ControllerModalBrowserChrome'

function sendUDP(payload) {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.controllerHandler) {
        window.webkit.messageHandlers.controllerHandler.postMessage(
            JSON.stringify({ event: 'UDP', command: JSON.stringify(payload) })
        )
    }
}

const SEC_KEYS = [
    { label: '↑', key: 'ArrowUp' },
    { label: '↓', key: 'ArrowDown' },
    { label: 'Space', key: 'Space' },
    { label: 'PgUp', key: 'PageUp' },
    { label: 'PgDn', key: 'PageDown' },
    { label: 'Esc', key: 'Escape' },
    { label: 'Enter', key: 'Enter' },
]

export default function ControllerModalBrowserSlideshow({ url, canGoBack, canGoForward, isFullscreen, onClose }) {
    const onKey = useCallback((key) => {
        sendUDP({ type: 'keystroke-special', key })
    }, [])

    const onChrome = useCallback((type) => {
        sendUDP({ type })
    }, [])

    return (
        <div style={s.container}>
            <ControllerModalBrowserChrome
                url={url}
                canGoBack={canGoBack}
                canGoForward={canGoForward}
                isFullscreen={isFullscreen}
                onTap={onChrome}
            />

            <div style={s.navRow}>
                <button style={s.navBtn} onClick={() => onKey('ArrowLeft')}>←</button>
                <button style={s.navBtn} onClick={() => onKey('ArrowRight')}>→</button>
            </div>

            <div style={s.secRow}>
                {SEC_KEYS.map(k => (
                    <button key={k.key} style={s.secBtn} onClick={() => onKey(k.key)}>
                        {k.label}
                    </button>
                ))}
            </div>

            <div style={s.presentRow}>
                <button style={s.presentBtn} onClick={() => sendUDP({ type: 'modal-browser-present' })}>
                    ▶ Present
                </button>
            </div>

            <span className={styles.joystickClose}>
                <div className={mstyles.closeBtnContainer}>
                    <div
                        className="round-btn"
                        onClick={onClose}
                        style={Globals.instance().getThemeStyle(['nav-menu-btn'])}
                    >
                        <CloseButton />
                    </div>
                </div>
            </span>
        </div>
    )
}

const s = {
    container: {
        position: 'fixed', inset: 0, zIndex: 9000,
        background: '#393939',
        display: 'flex', flexDirection: 'column',
        padding: 10,
        boxSizing: 'border-box',
        color: '#fff', fontFamily: 'sans-serif',
        userSelect: 'none',
    },
    navRow: {
        flex: 1,
        display: 'flex', gap: 20, padding: '40px 30px',
        alignItems: 'stretch',
    },
    navBtn: {
        flex: 1,
        fontSize: 64, fontWeight: 300,
        borderRadius: 16,
        border: '1px solid rgba(255,255,255,0.2)',
        background: 'rgba(255,255,255,0.1)',
        color: '#fff', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
    },
    secRow: {
        display: 'flex', gap: 6, padding: '0 20px 16px', flexWrap: 'wrap', flexShrink: 0,
    },
    secBtn: {
        flex: 1, minWidth: 52,
        padding: '13px 4px',
        borderRadius: 8,
        border: '1px solid rgba(255,255,255,0.15)',
        background: 'rgba(255,255,255,0.1)',
        color: '#fff', fontSize: 14, cursor: 'pointer',
    },
    presentRow: {
        padding: '0 20px 30px', flexShrink: 0,
    },
    presentBtn: {
        width: '100%',
        padding: '16px',
        borderRadius: 10,
        border: '1px solid rgba(68,162,244,0.5)',
        background: 'rgba(68,162,244,0.3)',
        color: '#fff', fontSize: 16, fontWeight: 600, cursor: 'pointer',
        letterSpacing: 0.5,
    },
}
